import { Entry } from '../Entry'

export function Entry20250910() {
  return (
    <Entry title="2025 Sep 10 - v3.10.18">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/18081/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
